export const statusBadgeMap: Record<
  string,
  { className: string; icon: string; label: string }
> = {
  PENDING: {
    className: 'badge-warning',
    icon: 'ni-clock',
    label: 'IncentiveOfferOperationStatus_Pending',
  },
  KYC_REVIEW: {
    className: 'badge-info',
    icon: 'ni-shield-check',
    label: 'IncentiveOfferOperationStatus_KYCReview',
  },
  VALIDATION: {
    className: 'badge-warning',
    icon: 'ni-clock',
    label: 'IncentiveOfferOperationStatus_Validation',
  },
  PAYMENT_PENDING: {
    className: 'badge-warning',
    icon: 'ni-wallet',
    label: 'IncentiveOfferOperationStatus_Payment',
  },
  TRANSFER_PENDING: {
    className: 'badge-info',
    icon: 'ni-swap',
    label: 'IncentiveOfferOperationStatus_Transfer',
  },
  COMPLETED: {
    className: 'badge-info',
    icon: 'ni-check-circle',
    label: 'IncentiveOfferOperationStatus_Completed',
  },
  CANCELLED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'IncentiveOfferOperationStatus_Cancelled',
  },
  REJECTED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'IncentiveOfferOperationStatus_Rejected',
  },
};

export const statusBannerMap: Record<
  string,
  { className: string; icon: string; heading: string; message: string }
> = {
  PENDING: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'IncentiveOfferOperationHeading_Pending',
    message: 'IncentiveOfferOperationMessage_Pending',
  },
  KYC_REVIEW: {
    className: 'alert-info',
    icon: 'ni-shield-check',
    heading: 'IncentiveOfferOperationHeading_KYCReview',
    message: 'IncentiveOfferOperationMessage_KYCReview',
  },
  VALIDATION: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'IncentiveOfferOperationHeading_Validation',
    message: 'IncentiveOfferOperationMessage_Validation',
  },
  PAYMENT_PENDING: {
    className: 'alert-warning',
    icon: 'ni-wallet',
    heading: 'IncentiveOfferOperationHeading_Payment',
    message: 'IncentiveOfferOperationMessage_Payment',
  },
  TRANSFER_PENDING: {
    className: 'alert-info',
    icon: 'ni-swap',
    heading: 'IncentiveOfferOperationHeading_Transfer',
    message: 'IncentiveOfferOperationMessage_Transfer',
  },
  COMPLETED: {
    className: 'alert-info',
    icon: 'ni-check-circle',
    heading: 'IncentiveOfferOperationHeading_Completed',
    message: 'IncentiveOfferOperationMessage_Completed',
  },
  CANCELLED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'IncentiveOfferOperationHeading_Cancelled',
    message: 'IncentiveOfferOperationMessage_Cancelled',
  },
  REJECTED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'IncentiveOfferOperationHeading_Rejected',
    message: 'IncentiveOfferOperationMessage_Rejected',
  },
};

export const timelineStepConfig: Record<
  string,
  { icon: string; description: string }
> = {
  PENDING: {
    icon: 'ni-file-text',
    description: 'IncentiveOfferOperationTimeline_Pending',
  },
  KYC_REVIEW: {
    icon: 'ni-shield-check',
    description: 'IncentiveOfferOperationTimeline_KYCReview',
  },
  VALIDATION: {
    icon: 'ni-building',
    description: 'IncentiveOfferOperationTimeline_Validation',
  },
  PAYMENT_PENDING: {
    icon: 'ni-cc-alt2',
    description: 'IncentiveOfferOperationTimeline_Payment',
  },
  TRANSFER_PENDING: {
    icon: 'ni-swap',
    description: 'IncentiveOfferOperationTimeline_Transfer',
  },
  COMPLETED: {
    icon: 'ni-file-check',
    description: 'IncentiveOfferOperationTimeline_Completed',
  },
  CANCELLED: {
    icon: 'ni-cross-circle',
    description: 'IncentiveOfferOperationTimeline_Cancelled',
  },
  REJECTED: {
    icon: 'ni-cross-circle',
    description: 'IncentiveOfferOperationTimeline_Rejected',
  },
};

export const activityAvatarMap: Record<string, { bg: string; icon: string }> = {
  PENDING: { bg: 'bg-primary-dim', icon: 'ni-user' },
  KYC_REVIEW: { bg: 'bg-info-dim', icon: 'ni-shield-check' },
  VALIDATION: { bg: 'bg-info-dim', icon: 'ni-send' },
  PAYMENT_PENDING: { bg: 'bg-warning-dim', icon: 'ni-wallet' },
  TRANSFER_PENDING: { bg: 'bg-info-dim', icon: 'ni-swap' },
  COMPLETED: { bg: 'bg-info-dim', icon: 'ni-check-circle' },
  CANCELLED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
  REJECTED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
};

export const menuStatusOptions = [
  { key: 'PENDING', icon: 'ni-file-text' },
  { key: 'KYC_REVIEW', icon: 'ni-shield-check' },
  { key: 'VALIDATION', icon: 'ni-building' },
  { key: 'PAYMENT_PENDING', icon: 'ni-cc-alt2' },
  { key: 'TRANSFER_PENDING', icon: 'ni-swap' },
  { key: 'COMPLETED', icon: 'ni-file-check' },
] as const;
